import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { colors } from "../../styles/variables";
import { useScreenSize } from "../../hooks/useScreenSize";

export const LocationIconSvg = () => {
  const theme = useContext(ThemeContext);
  const { isMobile } = useScreenSize();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="29.592"
      viewBox="0 0 20.353 29.592"
    >
      <g id="Group_111" transform="translate(-255.33 -114.861)">
        <path
          fill={isMobile ? theme.color.primary : colors.white}
          id="Path_167"
          d="M265.506 144.453a1 1 0 0 1-.758-.349c-.384-.446-9.418-11.041-9.418-19.066a10.177 10.177 0 1 1 20.353 0c0 8.025-9.034 18.62-9.418 19.067a1 1 0 0 1-.759.348zm0-27.592a8.186 8.186 0 0 0-8.176 8.177c0 6.007 6.018 14.119 8.176 16.835 2.159-2.716 8.177-10.828 8.177-16.835a8.186 8.186 0 0 0-8.177-8.177z"
          className="cls-1"
        />
        <path
          fill={isMobile ? theme.color.primary : colors.white}
          id="Path_168"
          d="M265.506 130.25a4.774 4.774 0 1 1 4.775-4.774 4.779 4.779 0 0 1-4.775 4.774zm0-7.548a2.774 2.774 0 1 0 2.775 2.774 2.777 2.777 0 0 0-2.775-2.776z"
          className="cls-1"
        />
      </g>
    </svg>
  );
};
